import { Input } from "antd";
import React from "react";

const EstimationFields = ({
  data,
  boardVisiblityData,
  setBoardVisibilityData,
}) => {

  const onChangeHandler = (e, item) => {
    const tempData = { ...boardVisiblityData };
    const EstimateData = tempData.onboarding_columns;
    EstimateData.map((field) => {
      if (field.id === item.id) {
        if (!field.hasOwnProperty('estimation')) {
          field.estimation = e.target.value;
        } else {
          field.estimation = e.target.value;
        }
      }
      return field;
    });
    tempData.onboarding_columns = EstimateData;
    setBoardVisibilityData(tempData);
  };

  return (
    <>
      {data.map((field, index) => (
        <div key={index} className="pt-2">
          {/* <label>{field.name}</label> */}
          <Input
            type={"text"}
            id={field.name}
            name={field.name}
            value={field?.estimation || ''}
            addonBefore={field.name}
            placeholder="ex:- 1 - 2"
            onChange={(e) => onChangeHandler(e, field)}
          />
        </div>
      ))}
      {/* <div>EstimationFields</div> */}
    </>
  );
};

export default EstimationFields;
